import { useEffect, useState } from "react";
import { ConvertToFloat, isValidArray } from "../../../../Layout/Common/common";
import { OrderItemRowPrint } from "./orderItemRowPrint";
import { OrderCartItemSkeleton } from "../../../../Skeleton/orderViewSkeleton";
import { ImageWithDefault } from "../../../../Layout/Common/imageWithDefault";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { useContext } from "react";
import { ISPICKUPONLY_MESSAGE } from "../../../../constants";
import { ProductLink } from "../../../../Layout/Common/productLink";
import { ItemReferenceInput } from "../../../../Layout/Common/itemReferenceInput";

export const OrderItemListPrint = ({ items }) => {
  const [orderItem, setOrderItem] = useState();

  const globalcontext = useContext(GlobalContext);
  useEffect(() => {
    if (items && items.orderItem) {
      setOrderItem(items.orderItem);
    }
  }, [items]);

  return (
    <div className="col-lg-12 mt-3 mt-md-4 billingShipping-wrapper">
      {/* Order Items */}
      <div className="order-address">
        <div className="card order-address-card">
          <div className="card-header">
            <h5>
              <span className="wes wes-download" />
              Order Details
            </h5>
          </div>
          {orderItem && isValidArray(orderItem.cartItem) ? (
            <div className="card-body order-address-body">
              <div className="row">
                <div className="row cart-products">
                  <div className="col-md-8 col-lg-8">
                    <div className="row">
                      <div className="col-lg-12">
                        <div>
                          {orderItem.cartItem.map((item, index) => (
                            <div
                              className="cart-added-products"
                              key={index}
                              data-id={item.prod_id}
                              style={{
                                opacity: 1,
                              }}
                            >
                              <div className="added-cartPro-img">
                                <ImageWithDefault src={item.image_th} alt="Product-image" />
                              </div>
                              <div className="added-cartPro-content">
                                <div className="added-cartPro-info">
                                  <div className="added-cartPro-item">
                                    <h6>
                                      <ProductLink to={item.product_url}>{item.description}</ProductLink>
                                    </h6>
                                    {isValidArray(globalcontext.pickupOnlyProduct) &&
                                      globalcontext.pickupOnlyProduct.includes(String(item.prod_id)) && (
                                        <div className="text-danger form-validation-message">
                                          {ISPICKUPONLY_MESSAGE}
                                        </div>
                                      )}
                                    <p>
                                      <span>Code: {item.prod_code}</span>${ConvertToFloat(item.price_ext_applied)} each
                                      ${ConvertToFloat(item.total_ext)}
                                    </p>
                                    <ItemReferenceInput item={item} readOnly />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                          <div className="col-md-4 col-lg-4 mt-0 mt-lg-0">
                            <div className="order-summary-details">
                              <div className="order-prices">
                                <div className="order-prices-list">
                                  <p>Sub Total</p>
                                  <span>$ {orderItem && ConvertToFloat(orderItem.totalcost)}</span>
                                </div>
                                <div className="order-prices-list">
                                  <p> Shipping</p>
                                  <span>$ {orderItem && ConvertToFloat(orderItem.shipcost)}</span>
                                </div>
                                <div className="order-prices-list">
                                  <p>Tax Amount</p>
                                  <span>$ {orderItem && ConvertToFloat(orderItem.totaltax)}</span>
                                </div>
                                <div className="order-prices-list" style={{ display: "none" }}>
                                  <p>Freight</p>
                                  <span>TBA</span>
                                </div>
                              </div>
                              <div className="order-prices-list order-prices-total">
                                <p>Total</p>
                                <span>$ {orderItem && ConvertToFloat(orderItem.totalIncTax)}</span>
                              </div>
                              Order Total
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <OrderCartItemSkeleton />
          )}
        </div>
      </div>
      {/* Order Items */}
    </div>
  );
};
